(function ($) {

    var $demoCheck = $('input[name=demo_mode]');
    var $demoFormBlock = $('#js-demo-mode-fields');
    var $sul = $('input[name=single_uses_left]');
    var $bul = $('input[name=batch_uses_left]');
    var $rpb = $('input[name=records_per_batch]');

    // check if it demo is checked on page load and update viewable components in form
    if ($demoCheck.prop("checked")) {
        $demoFormBlock.removeClass('hidden');
        $(this).val(1);
    } else {
        $(this).val(0);
        $demoFormBlock.addClass('hidden');
    }

    // when demo mode is changed, update the viewable components in form
    $demoCheck.on('click', function () {
        if (this.checked) {
            $(this).val(1);
            $demoFormBlock.removeClass('hidden');
        } else {
            $(this).val(0);
            $demoFormBlock.addClass('hidden');
            $sul.val(0);
            $bul.val(0);
            $rpb.val(0);
        }
    });

    var $adminCheck = $('input[name=council_admin]');

    // Set admin checkbox value on page load
    if ($adminCheck.prop("checked")) {
        $(this).val(1);
    } else {
        $(this).val(0);
    }

    // Update admin checkbox value
    $adminCheck.on('click', function () {
        if (this.checked) {
            $(this).val(1);
        } else {
            $(this).val(0);
        }
    });

})(jQuery);